import { FC, useEffect, useState } from "react";
import CurrentPolicy from "./CurrentPolicy";
import { useApiGet } from "../../../hooks";
import { PolicyDto } from "../../../dtos/policy-dto";
import { isAPITotallyComplete } from "../../../utilities/apiFunctions";
import { formattingKey } from "../../../utilities/enumFunctions";
import { PolicyStatusEnums } from "../../../dtos/policy-status-enums";
import { CurrentPolicyInfoWrapperProps } from "./InsuredInformationCurrentPolicyType";

const CurrentPolicyWrapper: FC<CurrentPolicyInfoWrapperProps> = ({
  tabKey,
  insuredId,
}) => {
  const [currentPolicyForInsured, setCurrentPolicyForInsured] =
    useState<PolicyDto | null>(null);
  const { responseGet, dispatchGet } = useApiGet<PolicyDto | undefined>(
    `api/Insured/GetCurrentPolicyForInsured?insuredId=${insuredId}`
  );

  useEffect(() => {
    if (currentPolicyForInsured === null) {
      dispatchGet();
    }
  }, []);

  useEffect(() => {
    if (isAPITotallyComplete(responseGet)) {
      const currentPolicy: any = responseGet.axiosResponse?.data;
      setCurrentPolicyForInsured({
        ...currentPolicy,
        status:
          (currentPolicy?.statusId ?? 0) !== 0
            ? formattingKey(PolicyStatusEnums[currentPolicy?.statusId])
            : "",
      });
    }
  }, [responseGet]);

  const getIsCurrentPolicy = () =>
    [
      PolicyStatusEnums.EXPIRED,
      PolicyStatusEnums.CANCELLED,
      PolicyStatusEnums.NEW_SUBMISSION,
    ].includes(currentPolicyForInsured?.statusId ?? 0) === false;

  return (
    <CurrentPolicy
      currentPolicy={currentPolicyForInsured}
      isCurrentPolicy={getIsCurrentPolicy()}
      tabKey={tabKey}
      insuredId={insuredId}
      statusName={currentPolicyForInsured?.status}
    />
  );
};

export default CurrentPolicyWrapper;
